// modules/inicio/components/RutaPrivada.js
// Envuelve una página que requiere sesión iniciada.
//   - rolesPermitidos: exige uno de esos roles (ej. <RutaPrivada rolesPermitidos={["admin"]}> para /admin).
//   - programaRequerido: exige que el usuario tenga ese programa asignado
//     (o "TODOS", o sea admin) — ej. <RutaPrivada programaRequerido="rbc"> para /rbc.
//     Sin esto, cualquier usuario logueado podía entrar a cualquier
//     estrategia escribiendo la URL a mano, aunque el Home la mostrara
//     bloqueada — el candado del Home era solo visual, no protegía la ruta real.

import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RutaPrivada({ children, rolesPermitidos, programaRequerido }) {
  const { user, cargando } = useAuth();

  if (cargando) return null; // evita parpadeo mientras se valida el token guardado

  if (!user) return <Navigate to="/login" replace />;

  if (rolesPermitidos && !rolesPermitidos.includes(user.rol)) {
    return <Navigate to="/" replace />;
  }

  if (programaRequerido) {
    const tieneAcceso =
      user.rol === "admin" ||
      user.programas?.includes("TODOS") ||
      user.programas?.includes(programaRequerido);
    if (!tieneAcceso) return <Navigate to="/" replace />;
  }

  return children;
}